export default "__VITE_ASSET__BhjZtzB9__"